import {createTheming} from '@callstack/react-theme-provider'
import {Branding, getBranding} from './branding'
import {getColors} from './colors'
import {getFonts} from './fonts'

export const createTheme = (_branding?: Branding) => {
  const branding = getBranding(_branding)
  return {
    ...getColors(branding.colors),
    ...getFonts(branding.fonts),
  }
}
export const defaultTheme = createTheme()
export type Theme = typeof defaultTheme
export const {ThemeProvider, withTheme, useTheme} = createTheming(defaultTheme)

// for styled-components theme compat
export * from './branding'
export * from './fonts'
